package com.karawek.core.ui.designcatalog.sections

import androidx.compose.foundation.layout.Arrangement.spacedBy
import androidx.compose.foundation.layout.Column
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.TextStyle
import com.karawek.core.ui.theme.CoreSpacing
import com.karawek.core.ui.theme.CoreTypography

@Composable
fun CatalogTypography() {
    Column(verticalArrangement = spacedBy(CoreSpacing.md)) {
        Text("Typography", style = CoreTypography.title)

        TextSample("Display", CoreTypography.display)
        TextSample("Headline", CoreTypography.headline)
        TextSample("Title", CoreTypography.title)
        TextSample("Body", CoreTypography.body)
        TextSample("Body Secondary", CoreTypography.bodySecondary)
        TextSample("Caption", CoreTypography.caption)
        TextSample("Footnote", CoreTypography.footnote)
    }
}

@Composable
private fun TextSample(
    label: String,
    style: TextStyle,
) {
    Column {
        Text(label, style = CoreTypography.caption)
        Text(
            text = "The quick brown fox jumps over the lazy dog",
            style = style,
        )
    }
}
